var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{attrs:{"title":_vm.$t('branding.previewConfirmation'),"srcdoc":_setup.previewHtml,"sandbox":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }